import mapProps from '../scripts/utils/map-props';
import InputTextarea from './input-textarea';

export default mapProps([
  {
    name: 'value',
  },
])(InputTextarea);
